import { render } from "./TableViewEditorCmp.vue?vue&type=template&id=948c3f54"
import script from "./TableViewEditorCmp.vue?vue&type=script&lang=js"
export * from "./TableViewEditorCmp.vue?vue&type=script&lang=js"

import "./TableViewEditorCmp.vue?vue&type=style&index=0&id=948c3f54&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__